import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../i18n";

export default function LanguageSelector({ size = "small", sx }) {
  const { i18n, t } = useTranslation();
  return (
    <TextField
      select
      size={size}
      value={i18n.resolvedLanguage === "ar" ? "ar" : "en"}
      onChange={(event) => i18n.changeLanguage(event.target.value)}
      label={t("common.language")}
      inputProps={{ "aria-label": t("common.language") }}
      sx={{ minWidth: 130, ...sx }}
    >
      <MenuItem value="en">English</MenuItem>
      <MenuItem value="ar">العربية</MenuItem>
    </TextField>
  );
}
